import { PayloadAction } from '../../../../../store.model';
import { ActionType } from '../commitment-narrative.action';
import { State } from '../commitment-narrative.state';

import { ToggleExpandNote } from './toggle-expand.action';

export function toggleExpandNoteReducer(
    state: State,
    action: PayloadAction<ActionType, ToggleExpandNote>,
): State {
    const { filteredRow } = state;
    const rowIndex = filteredRow.findIndex(
        (row) => row.id === action.payload.noteId,
    );

    if (rowIndex !== -1) {
        const updatedRow = {
            ...filteredRow[rowIndex],
            ctx: {
                ...filteredRow[rowIndex].ctx,
                isExpanded: !filteredRow[rowIndex].ctx.isExpanded,
            },
        };

        const updatedFilteredRow = [
            ...filteredRow.slice(0, rowIndex),
            updatedRow,
            ...filteredRow.slice(rowIndex + 1),
        ];

        return {
            ...state,
            filteredRow: updatedFilteredRow,
        };
    }

    return state;
}
